import React from "react";
import { Layout, Row, Col } from "antd";
import { useSelector } from "react-redux";
//component
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import TriggerDetail from "./trigger/trigger_detail";
import DialogQCDeny from "./dialog/dialog_qc_deny";
import DialogQCWarn from "./dialog/dialog_qc_warn";
import SegmentDetail from "./component/segment_detail";
import SectionCointaner from "component/sections/section_container";
//action

//selector
import "./style.css";
import { draftDialogDetailSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
import { draftBailiffDetailSelector } from "store/bailiff/draft/bailiff/draft_bailiff.selector";
import { URL } from "screen/00_Nav/url";
import DialogTimeline from "./dialog/dialog_timeline";

const SegmentScreen = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const detail = useSelector(draftBailiffDetailSelector);
  const dialog = useSelector(draftDialogDetailSelector);
  const name = detail?.name;
  const id = detail?.id;
  const slot = dialog?.slot;

  const breadCrum = [
    {
      title: "Bailiff",
      url: URL.bailiff,
    },
    {
      title: name,
      url: URL.bailiff + `/${id}`,
    },
    {
      title: slot,
      url: URL.bailiff + `/${id}` + `/${slot}`,
    },
  ];
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row justify={"center"} gutter={[0, 30]}>
        <Col align="center" xl={12} lg={12} md={22} xs={24}>
          <Row>
            <Col xl={24} lg={24} md={24} xs={24}>
              <SegmentDetail />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title="Dialog QC" />
      <SectionCointaner breadCrum={breadCrum}>
        <div style={{ padding: 20 }}>{renderBody()}</div>
        <DialogTimeline />
      </SectionCointaner>

      {/* Dialog */}
      <DialogQCDeny />
      <DialogQCWarn />
      {/* Trigger */}
      <TriggerDetail />
    </Layout>
  );
};

export default SegmentScreen;
